
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-tools-for-managers",
      function () {
        return require("private-next-pages/free-tools-for-managers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-tools-for-managers"])
      });
    }
  